import { render } from "./MenuTab.vue?vue&type=template&id=3130d58f"
import script from "./MenuTab.vue?vue&type=script&lang=js"
export * from "./MenuTab.vue?vue&type=script&lang=js"

import "./MenuTab.vue?vue&type=style&index=0&id=3130d58f&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__